import {
  hideDownloadAppBanner,
  setDownloadAppBannerHeight,
  settingsToggleChangeEmailForm,
  settingsToggleLinkEmailForm,
  showMobileNav,
  showStickyBottomBar,
  toggleCsatFeedback,
  toggleFullscreenImageModal,
  toggleLostLeadModal,
  toggleShowroundPromoModal,
  toggleNavMenuDrawer,
  togglePushNotificationOptIn,
  togglePushNotificationOptInAnalytics,
  toggleSpecialOfferPopup,
} from './actions';

export enum UIActionTypes {
  COPIED_URL = '[UI] Copied url',
  DEBOUNCED_GO_BACK_HOME = '[UI] Debounced go back home',
  RESET_COPIED_URL = '[UI] Reset copied url',
  TOGGLE_FULLSCREEN_IMAGE_MODAL = '[UI] Toggle fullscreen image modal',
  TOGGLE_LINK_EMAIL_FORM = '[UI] Show basic auth form titles',
  TOGGLE_NAV_MENU_DRAWER = '[UI] Toggle navigation menu drawer',
  TOGGLE_PUSH_NOTIFICATION_OPT_IN = '[UI] Toggle push notification opt in',
  TOGGLE_PUSH_NOTIFICATION_OPT_IN_ANALYTICS = '[Analytics] [UI] Toggle push notification opt in',
  TOGGLE_SEARCH_BAR = '[UI] Toggle search bar',
  TOGGLE_SETTINGS_CHANGE_EMAIL_FORM = '[UI] Toggle settings change email form',
  TOGGLE_SPECIAL_OFFER_POPUP = '[UI] Toggle special offer popup',
  TRIGGERED_SPECIAL_OFFER_POP_UP_ANALYTICS = '[Analytics] [UI] Triggered special offer popop',
  COUPLE_CLICKED_INBOX_MENU_ANALYTICS = '[Analytics] [UI] Couple clicked Messages item in burger menu',
  PARTICIPATED_IN_ABTEST_ANALYTICS = '[Analytics] [UI] User participated in AB Test',
  SET_NEXT_ACTION = '[UI] Set next action',
  SHOW_NEXT_ACTION = '[UI] Show next action',
  HIDE_NEXT_ACTION = '[UI] Hide next action',
  COMPLETE_NEXT_ACTION = '[UI] Complete next action',
  SHOW_MOBILE_NAV = '[UI] Show mobile nav',
  SHOW_STICKY_BOTTOM_BAR = '[UI] Show sticky bottom bar',
  TEST = '[UI] Test',
  IDENTIFY_VENUE_RECOMMENDED_SUPPLIERS = '[UI] Identify venue recommended suppliers',
  TOGGLE_NOT_INTERESTED_IN_SUPPLIER_MODAL = '[UI] Toggle lost lead modal',
  TOGGLE_SHOWROUND_PROMO_MODAL = '[UI] Toggle showround promo modal',
  TOGGLE_SUPPLIER_INTEREST_CONFIRMATION_MODAL = '[UI] Toggle supplier interest confirmation modal',
  CLICKED = '[UI] Clicked',
  TOGGLE_RATING_MODAL = '[UI] Toggle rating modal',
  SET_DOWNLOAD_APP_BANNER_HEIGHT = '[UI] Set download app banner height',
  HIDE_DOWNLOAD_APP_BANNER = '[UI] Hide download app banner',
  TOGGLE_CSAT_FEEDBACK = '[UI] Toggle CSAT feedback',
}

export type IToggleFullscreenImageModalAction = ReturnType<typeof toggleFullscreenImageModal>;
export type ISettingsToggleLinkEmailFormAction = ReturnType<typeof settingsToggleLinkEmailForm>;
export type ISettingsToggleChangeEmailFormAction = ReturnType<typeof settingsToggleChangeEmailForm>;
export type ITogglePushNotificationOptInAction = ReturnType<typeof togglePushNotificationOptIn>;
export type ITogglePushNotificationOptInAnalyticsAction = ReturnType<
  typeof togglePushNotificationOptInAnalytics
>;
export type IToggleNavMenuDrawerAction = ReturnType<typeof toggleNavMenuDrawer>;
export type IShowMobileNavAction = ReturnType<typeof showMobileNav>;
export type IShowStickyBottomBarAction = ReturnType<typeof showStickyBottomBar>;
export type IToggleSpecialOfferPopupAction = ReturnType<typeof toggleSpecialOfferPopup>;
export type IToggleLostLeadModal = ReturnType<typeof toggleLostLeadModal>;
export type IToggleShowroundPromoModal = ReturnType<typeof toggleShowroundPromoModal>;
export type ISetDownloadAppBannerHeightAction = ReturnType<typeof setDownloadAppBannerHeight>;
export type IHideDownloadAppBannerAction = ReturnType<typeof hideDownloadAppBanner>;
export type IToggleCsatFeedbackAction = ReturnType<typeof toggleCsatFeedback>;
